<script>
	import * as Accordion from '$lib/components/ui/accordion';

	// Answers come straight from the client's tour notes.
	const faqs = [
		{
			question: 'Which airports do I fly into and out of?',
			answer: 'Fly into Launceston and out of Hobart.'
		},
		{
			question: 'Can I hire golf clubs?',
			answer: 'Yes, hire golf clubs are available on request.'
		},
		{
			question: 'Are electric golf carts available?',
			answer:
				'Electric golf carts are available at the Championship Golf Course, Launceston on request.'
		},
		{
			question: 'Do we walk the other courses?',
			answer: 'All other courses are walking only, with a pull buggy included.'
		}
	];
</script>

<section id="faq" class="bg-white pb-16 lg:pb-24">
	<div class="mx-auto max-w-3xl px-4">
		<p class="text-sm font-semibold uppercase tracking-widest text-[#194139]">FAQ</p>
		<h2 class="mt-3 font-heading text-3xl font-semibold tracking-tight sm:text-4xl">
			Your questions answered
		</h2>
		<Accordion.Root class="mt-6 w-full" type="single" value="item-1">
			{#each faqs as item, i}
				<Accordion.Item value={`item-${i + 1}`} class="border-[#194139]/15">
					<Accordion.Trigger class="text-left font-heading text-base lg:text-lg"
						>{item.question}</Accordion.Trigger
					>
					<Accordion.Content class="py-2 pr-4 text-gray-700">
						{item.answer}
					</Accordion.Content>
				</Accordion.Item>
			{/each}
		</Accordion.Root>
	</div>
</section>
